import React, { useState } from 'react';
import { Grid } from '@material-ui/core';

import withWrappers from 'hocs/ReactKeyProvider';
import ZipCodeField from 'components/ZipCodeField';
import DeliveryWindowPicker from 'components/DeliveryWindowPicker';
import { Product } from 'pages/pdp/interface';
import { useControl } from 'hooks/useControl';
import { isFeatureEnabled } from 'utils/featureFlags';
import { PurchaseFormFieldNames as FIELD_NAMES } from 'constants/form';
import { ShippingMethodType } from 'components/DeliveryWindowPicker/interface';
import { ShippingMethodTypesSelect } from 'components/ShippingMethodTypesSelect';

interface ProductFormProps {
  product: Product;
}

const ProductForm = ({ product }: ProductFormProps) => {
  const [shippingOptions, setShippingOptions] = useState<ShippingMethodType[]>(
    [],
  );
  const control = useControl();
  if (!control) return null;

  return (
    <Grid container spacing={2} className="pb-2">
      <Grid item xs={12} sm={6}>
        <ZipCodeField control={control} required />
      </Grid>
      <Grid item xs={12} sm={6}>
        <DeliveryWindowPicker
          required
          control={control}
          productId={product.id}
          purchasable={product.purchasable}
          fieldName={FIELD_NAMES.date}
          setShippingOptions={setShippingOptions}
        />
      </Grid>
      {shippingOptions.length && isFeatureEnabled('shippingMethods') ? (
        <Grid item xs={12}>
          <ShippingMethodTypesSelect
            control={control}
            shippingMethodTypes={shippingOptions}
          />
        </Grid>
      ) : null}
    </Grid>
  );
};

export default withWrappers(ProductForm);
